import { Injectable }    from '@angular/core';
import { Headers, Http, Response } from '@angular/http';


import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { PriceItem } from './priceitem';

@Injectable()
export class PriceListService {

  private headers = new Headers({'Content-Type': 'application/json'});
 
  private pricelistUrl = 'data/pricelist.json';  // URL to web api

  constructor(private http: Http) { }

//////////////

getPriceList (): Promise<PriceItem[]> {
  return this.http.get(this.pricelistUrl)
                  .toPromise()
                  .then(this.extractData)
                  .catch(this.handleError);
}  
private extractData(res: Response) {

    let body = res.json();
    return body.data || {};
}

private handleError (error: Response | any) {
  // In a real world app, we might use a remote logging infrastructure
  let errMsg: string;
  if (error instanceof Response) {
    const body = error.json() || '';
    const err = body.error || JSON.stringify(body);
    errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
  } else {
    errMsg = error.message ? error.message : error.toString();
  }
  console.error(errMsg);
  return Promise.reject(errMsg);
}

//////////////

//   mapItems(response:Response): PriceItem[]{
//       console.log(response);
//       JSON.parse(JSON.stringify(response || null ));
//      return response.json().results.map(PriceItem)
//   }
//   getPriceList(): Promise<PriceItem[]> {
//       let headers = new Headers();
//       headers.append('X-SyncTimeout','30');
//       headers.append('Accept','application/json');
//       headers.append('Cache-Control','no-cache');
//       headers.append('Content-Type','application/json');
   
//     // this.http.get(this.pricelistUrl,{headers: headers})
//     //             .subscribe(res => this.data = res.json());
//      let pricel$ = this.http
//       .get(this.pricelistUrl, {headers: headers})
//       .toPromise()
//       .then(this.mapItems)
//       .catch(this.handleError);
     
//        return pricel$;
// }



//   getPriceItem(id: number): Promise<PriceItem> {
//     return this.getPriceList()
//                .then(pricelist => pricelist.find(priceitem => priceitem.id === id));
//   }

//   private handleError(error: any): Promise<any> {
//     console.error('An error occurred', error); // for demo purposes only
//     return Promise.reject(error.message || error);
//   }
}
